import { HTMLAttributes, memo, PropsWithChildren } from 'react';
import { SVG } from '../../svg';
import { Icons } from '../../icons';
import { useSubContext } from '../dropdown.context';
import { SubTriggerEl } from '../dropdown.styled';

type SubTriggerProps = {
  icon?: React.ReactNode;
  disabled?: boolean;
  _ref?: (el: HTMLElement | null) => void;
  _focused?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const SubTrigger = memo(
  ({
    children,
    icon,
    disabled,
    _ref,
    _focused,
    ...rest
  }: PropsWithChildren<SubTriggerProps>) => {
    const { toggle, triggerRef } = useSubContext();

    return (
      <SubTriggerEl
        ref={(el) => {
          (triggerRef as any).current = el;
          _ref?.(el);
        }}
        role="menuitem"
        tabIndex={-1}
        onClick={(e) => {
          e.stopPropagation();

          if (!disabled) {
            toggle();
          }
        }}
        onMouseEnter={() => {
          if (!disabled) {
            toggle();
          }
        }}
        {...rest}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {icon && icon}
          {children}
        </span>
        <SVG src={Icons.Chevron} props={{ size: '16px', deg: -90 }} />
      </SubTriggerEl>
    );
  }
);

SubTrigger.displayName = 'Dropdown.SubTrigger';
